import useSWRMutation from 'swr/mutation';
import payrollApiClient from '~/app/shared/util/api/payrollApiClient';
import { CREATE_COMPANY_ENDPOINT } from '../../constants';
import { CreateCompanyRequestBody } from '../../types';

const createCompany = (url: string, { arg }: { arg: { company: CreateCompanyRequestBody } }) => {
    return payrollApiClient.post(url, arg.company);
};

export const useCreateCompany = () => {
    const mutation = useSWRMutation(CREATE_COMPANY_ENDPOINT, createCompany);
    return mutation;
};
